import React from 'react';
import { CacheProvider } from '@emotion/react';
import { SharedElementsLayout, StyleLayout } from './src/layout';
import appInsightsService, { setDevice } from './src/utils/AppInsights.service';
import createEmotionCache from './src/utils/emotion-cache';

let emotionCache;

export const wrapRootElement = ({ element }) => {
  if (!emotionCache) {
    emotionCache = createEmotionCache();
  }

  return <CacheProvider value={emotionCache}>{element}</CacheProvider>;
};

export const wrapPageElement = ({ element, props }) => {
  return (
    <StyleLayout>
      <SharedElementsLayout path={props.uri}>{element}</SharedElementsLayout>
    </StyleLayout>
  );
};

export const onInitialClientRender = () => {
  setDevice();
};

export const onClientEntry = () => {
  if (appInsightsService) {
    appInsightsService.loadAppInsights();
  }
};
